import type { CareLevel } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../../../utility/client';

export const postCareLevel = async (careLevel: Omit<CareLevel, 'id'>) => {
  const res = await Api.post<CareLevel>('/admin/v1/care-levels', careLevel);
  return res.data;
};
